export const gradientPresets = [
  // PEA Brand Colors
  { name: 'PEA Purple', value: 'linear-gradient(135deg, #8D2F88 0%, #6919A2 100%)' },
  { name: 'PEA Light', value: 'linear-gradient(135deg, #F4E8F6 0%, #EFEEF4 100%)' },
  
  // Modern & Clean
  { name: 'Ocean Blue', value: 'linear-gradient(135deg, #00c6fb 0%, #005bea 100%)' },
  { name: 'Warm Sunset', value: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)' },
  { name: 'Nature Green', value: 'linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%)' },
  { name: 'Midnight', value: 'linear-gradient(135deg, #232526 0%, #414345 100%)' },
  { name: 'Royal Gold', value: 'linear-gradient(135deg, #BF953F 0%, #FCF6BA 50%, #B38728 100%)' },
  { name: 'Clean Gray', value: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)' },
  { name: 'Neon Life', value: 'linear-gradient(135deg, #B621FE 0%, #1FD1F9 100%)' },
  { name: 'Cherry', value: 'linear-gradient(135deg, #eb3349 0%, #f45c43 100%)' },
  
  // Pastel
  { name: 'Pastel Dream', value: 'linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%)' },
  { name: 'Peach', value: 'linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)' },
  { name: 'Minty', value: 'linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%)' },
  { name: 'Lavender', value: 'linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%)' },
  
  // Corporate
  { name: 'Deep Blue', value: 'linear-gradient(to right, #6a11cb 0%, #2575fc 100%)' },
  { name: 'Professional', value: 'linear-gradient(to right, #4facfe 0%, #00f2fe 100%)' },
  { name: 'Dark Knight', value: 'linear-gradient(60deg, #29323c 0%, #485563 100%)' },
  
  // Vibrant
  { name: 'Summer Dog', value: 'linear-gradient(120deg, #a1c4fd 0%, #c2e9fb 100%)' },
  { name: 'Faerie', value: 'linear-gradient(to top, #9be15d 0%, #00e3ae 100%)' },
  { name: 'Morning', value: 'linear-gradient(120deg, #f6d365 0%, #fda085 100%)' },
  { name: 'Rainy Ashville', value: 'linear-gradient(to top, #fbc2eb 0%, #a6c1ee 100%)' },
  { name: 'Frozen Dreams', value: 'linear-gradient(to top, #fdcbf1 0%, #e6dee9 100%)' },
  { name: 'Dusty Grass', value: 'linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%)' },
  { name: 'Spring Warmth', value: 'linear-gradient(to top, #fad0c4 0%, #ffd1ff 100%)' },
  { name: 'Night Fade', value: 'linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%)' },
  { name: 'Sunny Morning', value: 'linear-gradient(120deg, #f6d365 0%, #fda085 100%)' },
  { name: 'Juicy Orange', value: 'linear-gradient(to right, #ff8008 0%, #ffc837 100%)' },
  { name: 'Sea Shore', value: 'linear-gradient(to top, #209cff 0%, #68e0cf 100%)' },
  
  // Abstract
  { name: 'Abstract 1', value: 'linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%)' },
  { name: 'Abstract 2', value: 'linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%)' },
  { name: 'Abstract 3', value: 'linear-gradient(to top, #fad0c4 0%, #ffd1ff 100%)' },
  { name: 'Abstract 4', value: 'linear-gradient(to right, #ffecd2 0%, #fcb69f 100%)' },
  { name: 'Abstract 5', value: 'linear-gradient(to right, #ff8177 0%, #ff867a 0%, #ff8c7f 21%, #f99185 52%, #cf556c 78%, #b12a5b 100%)' },
  
  // Dark
  { name: 'Midnight City', value: 'linear-gradient(to top, #232526 0%, #414345 100%)' },
  { name: 'Royal Black', value: 'linear-gradient(to right, #141e30 0%, #243b55 100%)' },
  { name: 'Asteroid', value: 'linear-gradient(to right, #0f2027 0%, #203a43 50%, #2c5364 100%)' }
];
